import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  Button,
  Row,
  Col,
  DatePicker,
  Steps,
  message,
  Alert,
} from "antd";
import "dayjs/locale/es-mx";
import store from "../../../../../controllers/store";
import { useSelector } from "react-redux";
import SelectKnowledgeArea from "../../Elements/Select-Knowledge-Area";
import SelectKnowledgeSpecialty from "../../Elements/Select-Knowledge-Specialty";
import { InboxOutlined } from "@ant-design/icons";
import { Upload } from "antd";
import {
  UploadImageAnnouncement,
  UploadRawFileAnnouncement,
} from "../../../../../controllers/store/actions/announcement/upload-image-action";
import { update } from "../../../../../controllers/store/actions/announcement/update-announcement-actions";
import dayjs from "dayjs";

const { Dragger } = Upload;

interface Props {
  loading?: boolean;
  announcement: any;
  visible: boolean;
  onUpdated: () => void;
  onCancel: () => void;
}

const dispatch = store.dispatch;
const UpdateAnnouncementModal: React.FC<Props> = (props: Props) => {
  const [form] = Form.useForm();
  const [formGlobal, setFormGlobal] = useState<any>({});
  const announcementImageState = useSelector(
    (state: any) => state.announcementImage
  );
  const [current, setCurrent] = useState(0);
  const updatedSearcher = useSelector((state: any) => state.updatedSearcher);

  useEffect(() => {
    if (props.announcement) {
      form.setFieldsValue({
        ...props.announcement,
        areas: props.announcement?.areas.map((area: any) => ({
          value: area.AREA_DE_CONOCIMIENTO_id.AREA_DE_CONOCIMIENTO,
        })),
        sub_areas: props.announcement?.sub_areas.map((subArea: any) => ({
          value:
            subArea.ESPECIALIDAD_DE_CONOCIMIENTO_id
              .ESPECIALIDAD_DE_CONOCIMIENTO,
        })),
        visibility_start_date: dayjs(props.announcement?.visibility_start_date),
        visibility_end_date: dayjs(props.announcement?.visibility_end_date),
        document: announcementImageState.document?.id,
      });
    }
  }, [form, props.announcement]);

  const next = () => {
    form
      .validateFields()
      .then(async (values: any) => {
        const areas = values.areas?.map((e: any) => ({
          AREA_DE_CONOCIMIENTO_id: e.value,
        }));
        const sub_areas = values.sub_areas?.map((e: any) => ({
          ESPECIALIDAD_DE_CONOCIMIENTO_id: e.value,
        }));

        if (!areas && !sub_areas) {
          setFormGlobal({
            ...formGlobal,
            ...values,
            image: announcementImageState.upload?.id,
          });
        } else {
          setFormGlobal({
            ...formGlobal,
            ...values,
            image: announcementImageState.upload?.id,
            areas,
            sub_areas,
          });
        }
        setCurrent(current + 1);
      })
      .catch((e: any) => {
        console.log(e.message);
      });
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const steps = [
    {
      title: "Información básica del proyecto",
      content: (
        <>
          <Row gutter={[8, 8]} style={{ width: "100%", marginTop: 30 }}>
            <Col span={24}>
              <Form.Item
                label="Nombre del proyecto"
                name="nombre"
                rules={[
                  { required: true, message: "Por favor ingrese el nombre" },
                ]}
              >
                <Input placeholder="Nombre del proyecto" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Url de convocatoria" name="url">
                <Input placeholder="Url de convocatoria" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Institución" name="institucion">
                <Input placeholder="Institución" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Responsable" name="responsable">
                <Input placeholder="Responsable" />
              </Form.Item>
            </Col>

            {/*
              <Col xs={24} sm={12} md={8} lg={12}>
              <Form.Item
                label="Area general"
                name="areas"
                rules={[
                  {
                    type: "array",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectKnowledgeArea
                  mode={"multiple"}
                  onClear={() => {}}
                  style={{ width: "100%" }}
                  size="large"
                  onChange={(selected: any) => {
                    form.setFieldValue("area", selected);
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12}>
              <Form.Item
                label="Área específica"
                name="sub_areas"
                rules={[
                  {
                    type: "array",
                    required: true,
                    message: "El campo es obligatorio",
                  },
                ]}
              >
                <SelectKnowledgeSpecialty
                  onClear={() => {}}
                  size="large"
                  mode={"multiple"}
                  onChange={(selected: any) => {
                    form.setFieldValue("sub_areas", selected);
                  }}
                />
              </Form.Item>
            </Col>
            */}
            <Col span={12}>
              <Form.Item
                label="Fecha inicio de visibilidad"
                name="visibility_start_date"
                rules={[
                  {
                    required: true,
                    message:
                      "Por favor ingrese la fecha de inicio de visibilidad",
                  },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  size="large"
                  placeholder="Fecha de inicio de visibilidad"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Fecha fin de visibilidad"
                name="visibility_end_date"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese la fecha de fin de visibilidad",
                  },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  size="large"
                  placeholder="Fecha de fin de visibilidad"
                />
              </Form.Item>
            </Col>
          </Row>
        </>
      ),
    },
    {
      title: "Información de detalle",
      content: (
        <>
          <Row gutter={[8, 8]} style={{ width: "100%", marginTop: 30 }}>
            <Col span={24}>
              <Form.Item
                label="Descripción detallada"
                name="descripcion_detallada"
              >
                <Input.TextArea placeholder="Descripción detallada" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Solución" name="solucion">
                <Input.TextArea placeholder="Solución" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="Expectativas de la solución"
                name="expectativas_solucion"
              >
                <Input.TextArea placeholder="Expectativas de la solución" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="Requisitos obligatorios"
                name="requisitos_obligatorios"
              >
                <Input.TextArea placeholder="Requisitos obligatorios" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="Requisitos deseables"
                name="requisitos_deseables"
              >
                <Input.TextArea placeholder="Requisitos deseables" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="Requisitos no deseables"
                name="requisitos_no_deseables"
              >
                <Input.TextArea placeholder="Requisitos no deseados" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Tecnologías" name="tecnologias">
                <Input placeholder="Tecnologías" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Tipo de organización" name="tipo_organizacion">
                <Input placeholder="Tipo de organización" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Presupuesto" name="presupuesto">
                <Input placeholder="Presupuesto" />
              </Form.Item>
            </Col>
          </Row>
        </>
      ),
    },
    {
      title: "Presentación",
      content: (
        <>
          <br />
          <Alert
            message="Se recomienda subir el banner con las dimensiones 1920x520 píxeles para obtener una mejor visualización."
            type="info"
          />
          <br />
          <Dragger
            name="file"
            multiple
            action="https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188"
            onChange={(info) => {
              const { status } = info.file;
              if (status !== "uploading") {
                console.log(info.file, info.fileList);
              }
              if (status === "done") {
                message.success(
                  `${info.file.name} Archivo subido correctamente.`
                );
              } else if (status === "error") {
                message.error(
                  `${info.file.name} Falló la subidad del archivo.`
                );
              }
            }}
            onDrop={(e) => {
              console.log("Dropped files", e.dataTransfer.files);
            }}
            customRequest={async ({ file, onSuccess, onError }) => {
              try {
                await dispatch(UploadImageAnnouncement(file as File));
                if (onSuccess) onSuccess("Ok");
              } catch (e: any) {
                if (onError) {
                  onError(e);
                }
              }
            }}
            style={{ marginTop: 20 }}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Click o arrastra los archivos a esta área para subir.
            </p>
          </Dragger>
          <p>Adjuntar documento de presentación</p>
          <Dragger
            name="file"
            multiple
            action="https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188"
            onChange={(info) => {
              const { status } = info.file;
              if (status !== "uploading") {
                console.log(info.file, info.fileList);
              }
              if (status === "done") {
                message.success(
                  `${info.file.name} Archivo subido correctamente.`
                );
              } else if (status === "error") {
                message.error(
                  `${info.file.name} Falló la subidad del archivo.`
                );
              }
            }}
            onDrop={(e) => {
              console.log("Dropped files", e.dataTransfer.files);
            }}
            customRequest={async ({ file, onSuccess, onError }) => {
              try {
                await dispatch(UploadRawFileAnnouncement(file as File));
                if (onSuccess) onSuccess("Ok");
              } catch (e: any) {
                if (onError) {
                  onError(e);
                }
              }
            }}
            style={{ marginTop: 20 }}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Click o arrastra los archivos a esta área para subir.
            </p>
          </Dragger>
        </>
      ),
    },
  ];

  const handleFinish = async () => {
    try {
      await dispatch(
        update(props.announcement.id, {
          ...formGlobal,
          image: announcementImageState.upload?.id,
        })
      );
      props.onUpdated();
    } catch (error) {
      console.error("Error al actualizar la convocatoria", error);
    }
  };

  return (
    <Modal
      width={800}
      visible={props.visible}
      title={"Convocatoria"}
      footer={
        <div style={{ marginTop: 24 }}>
          {current < steps.length - 1 && (
            <Button type="primary" onClick={() => next()}>
              Siguiente
            </Button>
          )}
          {current === steps.length - 1 && (
            <Button
              loading={updatedSearcher?.isLoading}
              type="primary"
              onClick={handleFinish}
            >
              Guardar
            </Button>
          )}
          {current > 0 && (
            <Button style={{ margin: "0 8px" }} onClick={() => prev()}>
              Anterior
            </Button>
          )}
        </div>
      }
      onCancel={props.onCancel}
    >
      <>
        <Steps
          current={current}
          items={steps.map((item) => ({ key: item.title, title: item.title }))}
        />
        <Form form={form} layout="vertical" name="UpdateAnnouncement">
          {steps[current].content}
        </Form>
      </>
    </Modal>
  );
};

export default UpdateAnnouncementModal;
